import React from 'react';
import { useDry } from '../../dry/DryContext';

export default function PendingSyncIndicator() {
  const { pendingSync } = useDry();
  if (!pendingSync || (pendingSync.pending === 0 && pendingSync.failed === 0)) return null;
  const failed = pendingSync.failed > 0;
  return (
    <span
      className={`inline-flex items-center gap-1 px-2 py-1 rounded-full text-xs ${failed ? 'bg-red-100 text-red-700' : 'bg-amber-100 text-amber-700'}`}
      title={failed ? `${pendingSync.failed} failed to sync` : `${pendingSync.pending} waiting to sync`}
      role="status"
    >
      {failed ? `${pendingSync.failed} failed` : `${pendingSync.pending} pending`}
    </span>
  );
}
